import { render } from "./MyVk.vue?vue&type=template&id=4dfc120e"
import script from "./MyVk.vue?vue&type=script&lang=js"
export * from "./MyVk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__